module.exports = __webpack_public_path__ + "static/icon00295051426e71e53329783c94a5a2cccc12.png";